export default __webpack_public_path__ + "static/media/ic_payment_white.3eb68c91.svg";